import FilterCreate from "../FilterCreate/FilterCreate.jsx";
import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import api from "../../utils/api";
import LoadingLayout from "../../layouts/LoadingLayout/LoadingLayout.js";

function FilterEdit() {
    const [ DatabaseList, setDatabaseList ] = useState(null)
    const [ Database, setDatabase ] = useState(null)
    const [ filter, setFilter ] = useState(null)
    const { fid } = useParams();
    const DatabaseId = new URLSearchParams(window.location.search).get("server_id")
    const returnTo = new URLSearchParams(window.location.search).get("returnTo")

    useEffect(() => {
        if(fid !== undefined){
            api.getFilter(fid).then((data) => {
                setFilter(data)
            })
        }

        if (DatabaseId !== null && DatabaseId !== undefined) {
            api.getDatabase(DatabaseId).then(Database => {
                setDatabase(Database)
            })
        }

        api.listDatabases().then((data) => {
            setDatabaseList(data)
        })

    }, []);

    if (filter === null || filter === undefined) {
        return <LoadingLayout />
    }

     return <FilterCreate
          returnTo={returnTo}
          edit_id={filter.id}
          defaultDatabases={DatabaseList}
          defaultName={filter.name}
          defaultDescription={filter.description}
          defaultSelectedDatabase={filter.server}
          defaultSelectedSchema={filter.table ? filter.table.tableSchema : null}
          defaultSelectedTable={filter.table}
          defaultSelectedRoles={filter.roles}
          defaultConditions={filter.conditions}
          defaultActions={filter.actions}
          defaultUsers={filter.dbUsernames}
          pageTitle={"Edit Filter"}
    />
}

export default FilterEdit;